<template>
    <div class="reset-view right_auth">
        <div class="theme">
            修改密码
        </div>
        <div class="form_modal">
            <p class="error">{{remote}}</p>
            <div class="form_ctr">
                <p class="error">{{old.error}}</p>
                <label class="req">旧密码</label>
                <input input="text" onfocus="this.type='password'" class="w200" @blur="required" v-model="old.model">
            </div>
            <div class="form_ctr">
                <p class="error">{{pwd.error}}</p>
                <label class="req">新密码</label>
                <input input="text" onfocus="this.type='password'" class="w200" @blur='password' v-model="pwd.model">
            </div>
            <div class="form_ctr">
                <p class="error">{{certain.error}}</p>
                <label class="req">确认密码</label>
                <input input="text" onfocus="this.type='password'" class="w200" @blur="confirm" v-model="certain.model">
                <p class="error"></p>
            </div>
            <ul class="btn" style="margin-top: 10px; margin-left: -85px;">
                <li @click="reset">提交</li>
            </ul>
        </div>
    </div>
</template>
<script type="es6">
    import {util} from '../service/util'
    let API = util.api(['UPDATEPWD']);
    export default{
        data(){
            return {
                old:{
                    model:'',
                    error:'',
                    state:'false'
                },
                pwd:{
                    model:'',
                    error:'',
                    state:'false'
                },
                certain:{
                    model:'',
                    error:'',
                    state:'false'
                },
                remote:'',
                state:'false'
            }
        },
        computed:{
           param(){
             return {
                 oldPass:this.old.model,
                 userPass:this.pwd.model,
                 newPassCopy:this.certain.model
             }
           },
           access(){
               if(this.old.state && this.pwd.state && this.certain.state){
                   return true;
               }else {
                   return false;
               }
           }
        },
        methods:{
            required(){
                if(this.old.model == ''){
                    this.old.error = '请输入旧密码';
                    this.old.state = false;
                }else {
                    this.old.error = '';
                    this.old.state = true;
                }
            },
            password(){
                var _this = this;
                if(!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(_this.pwd.model)){
                    this.pwd.error = '密码必须为6-16位数字和字母组成';
                    this.pwd.state = false;
                }else {
                    this.pwd.error = '';
                    this.pwd.state = true;
                }
            },
            confirm(){
                if(this.pwd.model != this.certain.model){
                    this.certain.error = '与新密码不一致';
                    this.certain.state = false;
                }else {
                    this.certain.error = '';
                    this.certain.state = true;
                }
            },
            reset(){
                if(this.access){
                    let _this = this;
                    util.kAjax(API.UPDATEPWD,_this.param,res=>{
                        _this.remote = '修改密码成功';
                        setTimeout(function () {
                            Object.assign(_this.$data, _this.$options.data());
                        },1500);
                    },err=>{
                        _this.remote = err;
                        setTimeout(function () {
                            Object.assign(_this.$data, _this.$options.data());
                        },1500);
                    })
                }
            }
        },
        mounted(){

        }
    }
</script>


// WEBPACK FOOTER //
// ResetView.vue?3aa35e0d